export default "__VITE_ASSET__CS6tJcy2__"